/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit App/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Account from './Account/index'
import Authenticate from './Authenticate/index'
import Loading from './Loading/index'
import React from 'react'
import RuntimeError from './RuntimeError/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function App({
  children,
  viewPath = "/App"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Loading'
  return (<React.Fragment
>
<div
  data-testid="App.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Authenticate'}>
<Authenticate
  viewPath={`${viewPath}/Authenticate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Account'}>
<Account
  viewPath={`${viewPath}/Account`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'RuntimeError'}>
<RuntimeError
  viewPath={`${viewPath}/RuntimeError`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}